import { render } from "./article.vue?vue&type=template&id=47f44231"
import script from "./article.vue?vue&type=script&lang=js"
export * from "./article.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/NM12r8skh/0/website/official-website-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__